import * as React from 'react'
import { Drawer, makeStyles } from '@material-ui/core'
import { useQueryClient } from 'react-query'
import CloseDrawer from '../../components/CloseDrawer/CloseDrawer'
import SelectEventType from '../../components/SelectEventType/SelectEventType'
import { useTeamCalendarContext } from '../../context/useTeamCalendarContext'
import calendarPageStyles from './CalendarPage/calendarPage.styles'
import QueryKeys from '../../utils/constants/queryKeys'
import useHistoryPush from '../../hooks/useHistoryPush'
import LoaderDots from '../../components/loaders/LoaderDots/LoaderDots'
import { EVENT_TYPE_FORMS } from '../../utils/constants/eventTypeForms'

const CreateEventDrawer = () => {
  const {
    setClickedEventId,
    createEventDrawerOpen,
    setDateClick,
    selectedEventType,
    event,
    formDirty,
    createEvent,
    updateEvent,
    eventTypes,
    setSelectedEventType,
    clickedEventId,
    setFormDirty,
    currentTeam,
    teams,
    dateClick,
    eventsRaw,
    setEvents,
    setCreateEventDrawerOpen,
    courts,
    setGamedayId,
    eventIsPlaceholder,
  } = useTeamCalendarContext()
  const queryClient = useQueryClient()
  const { redirect, pathname } = useHistoryPush()
  const useStyles = makeStyles(calendarPageStyles)
  const classes = useStyles()

  // The Game view renders its own close (X) inside GameFormHeader, so the standalone
  // top-right CloseDrawer would double it — only show it for the other event types.
  const isGame = (selectedEventType?.code ?? EVENT_TYPE_FORMS.GAME) === EVENT_TYPE_FORMS.GAME

  const handleCloseDrawerClick = () => {
    queryClient.invalidateQueries(QueryKeys.GET_EVENTS)
    setCreateEventDrawerOpen(false)
    setClickedEventId('')
    setDateClick({})
    setGamedayId(null) // Clear gamedayId when closing
    redirect(`/${pathname.split('/')[1]}`, [], ['breadcrumb', 'eventType'])
  }

  return (
    <Drawer
      open={createEventDrawerOpen}
      anchor='right'
      classes={{ paper: classes.drawerPaper }}
      disableEnforceFocus
    >
      <div className={classes.drawerContainer}>
        {!isGame && <CloseDrawer onClick={handleCloseDrawerClick} />}
        {/* The form freezes its initial values on mount, and the calendar-list placeholder has
            no court or broadcast, so an edit opened straight from a row waits for the detail. */}
        {(clickedEventId && event && !eventIsPlaceholder) || !clickedEventId ? (
          <SelectEventType
            selectedEventType={selectedEventType}
            event={event}
            formDirty={formDirty}
            setFormDirty={setFormDirty}
            createEvent={createEvent}
            updateEvent={updateEvent}
            eventTypes={eventTypes}
            setSelectedEventType={setSelectedEventType}
            clickedEventId={clickedEventId}
            currentTeam={currentTeam}
            teams={teams}
            dateClick={dateClick}
            eventsRaw={eventsRaw}
            setEvents={setEvents}
            disabled={event}
            courts={courts}
            onCancel={handleCloseDrawerClick}
          />
        ) : (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <LoaderDots style={{width: 50, height: 50}} />
          </div>
        )}
      </div>
    </Drawer>
  )
}
export default CreateEventDrawer
